import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=e0cbdb4a&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"
import style0 from "./footBar.vue?vue&type=style&index=0&id=e0cbdb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cbdb4a",
  null
  
)

export default component.exports